/**
 * All Sliders
 * based on Swiper 4
 * @url : http://idangero.us/swiper/api/
 */

import Swiper from 'swiper'

// @TODO Custom Transition Effect
// https://codepen.io/udovichenko/pen/LGeQae

/**
 * Lists Swiper
 * homepage
 */
const listsSwiper = document.querySelectorAll('.js-swiper-list')

if (listsSwiper.length) {
  for (const swiper of listsSwiper) {

    // Swiper instance
    const listsSwiperInstance = new Swiper(swiper, {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      preloadImages: false,
      lazy: {
        loadPrevNext: true
      },
      autoplay: {
        delay: 8000,
      },
      speed: 1000,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      init: false
    })

    // Init only if there is 2 or more slides
    const nbSlides = swiper.querySelectorAll('.swiper-slide')

    if (nbSlides.length > 1) {
      listsSwiperInstance.init()
    }
  }
}

/**
 * Page Standard Swiper
 * Default + freemode
 */
// Default
const psSwiper = document.querySelectorAll('.js-swiper-page-standard')

if (psSwiper.length) {
  for (const swiper of psSwiper) {

    // Swiper instance
    const psSwiperInstance = new Swiper(swiper, {
      slidesPerView: 1,
      loop: true,
      speed: 700,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      init: false
    })

    // Init only if there is 2 or more slides
    const nbSlides = swiper.querySelectorAll('.swiper-slide')

    if (nbSlides.length > 1) {
      psSwiperInstance.init()
    }
  }
}

// Freemode
const swiperFreemode = document.querySelectorAll('.js-swiper-freemode')

if (swiperFreemode.length) {
  for (const swiper of swiperFreemode) {

    // Swiper instance
    const swiperFreeModeInstance = new Swiper(swiper, {
      slidesPerView: 'auto',
      centeredSlides: true,
      grabCursor: true,
      freeMode: true,
      spaceBetween: 30,
      speed: 700,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      init: false,
      on: {
        imagesReady() {
          // fix for firefox
          setTimeout(() => {
            swiperFreeModeInstance.update();
          }, 1000)
        },
      }
    })

    // Init only if there is 2 or more slides
    const nbSlides = swiper.querySelectorAll('.swiper-slide')

    if (nbSlides.length > 1) {
      swiperFreeModeInstance.init()
    }
  }
}


/**
 * Product Detail Swiper
 * with custom bullets (original idea from F-one)
 */
const swiperProductThumb = document.querySelector('.js-swiper-product-thumb')

if (swiperProductThumb) {

  // Some vars
  const slides = swiperProductThumb.querySelectorAll('.swiper-slide[data-ref]')
  const productRef = swiperProductThumb.querySelector('.swiper-pagination-label')
  let datas = []

  // Create an array of data objects
  for (const [index, slide] of slides.entries()) {
    datas[index] = {
      ref: slide.dataset.ref,
      color: slide.dataset.color
    }
  }

  // Swiper instance
  const swiperProductThumbInstance = new Swiper(swiperProductThumb, {
    slidesPerView: 1,
    loop: true,
    speed: 700,
    // init: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function(index, className) {
        return `<span class="${className}" style="background-color:${datas[index].color}"></span>`
      }
    }
  })

  const displayProductRef = (swiperInstance) => {
    const refs = productRef.querySelectorAll('li')
    for (const ref of refs) {
      ref.classList.remove('is-active')
    }
    refs[swiperInstance.realIndex].classList.add('is-active')
  }

  // Product ref insertion + change
  swiperProductThumbInstance.on('slideChange', () => {
    displayProductRef(swiperProductThumbInstance)
  });

  // If we have only one item, we need to keep pagination
  // But we dont want any swipe event
  if (slides.length === 1) {
    swiperProductThumbInstance.destroy()
  }

}


/**
 * Filters Swiper
 * Freemode + init if total width exceeds viewport's width
 */
const filtersSwiper = document.querySelector('.js-swiper-filters')

if (filtersSwiper) {

  // Swiper instance
  const filtersSwiperInstance = new Swiper(filtersSwiper, {
    slidesPerView: 'auto',
    freeMode: true,
    speed: 700,
    init: false
  })

  // Init only if there is 2 or more slides & if total width exceeds view
  const nbSlides = filtersSwiper.querySelectorAll('.swiper-slide')

  if (nbSlides.length > 1) {

    // Swiper Width
    const swiperDims = filtersSwiper.getBoundingClientRect()
    let slidesDims = 0
    for (const slide of nbSlides) {
      slidesDims = slidesDims + slide.getBoundingClientRect().width
    }

    // Init
    if (slidesDims > swiperDims.width) {
      filtersSwiperInstance.init()
    }
  }

}
